import type { CheckoutTravelerText } from '@voll-intelligence/intelligence-ui-kit/checkout';
import type { UseOneClickCheckout } from '../../core/use_one_click_checkout.js';

type Slice = UseOneClickCheckout['form']['travelers'][number];

/** No modo `'requester'`, só o titular de cada quarto tem o campo (#5522). */
export function ownsAllocation(flow: UseOneClickCheckout, slice: Slice): boolean {
  return (
    flow.allocationOwner !== 'requester' ||
    flow.form.rooms.some((room) => room[0] === slice.traveler.id)
  );
}

/** No lugar do rateio do acompanhante, de quem é o rateio (a mesma nota da
 *  tela cheia): do titular do quarto dele, ou do solicitante quando é ele. */
export function ownerAllocationHint(
  flow: UseOneClickCheckout,
  requesterId: string | undefined,
  labels: CheckoutTravelerText,
  slice: Slice,
): string {
  const holderId = flow.form.rooms.find((room) => room.includes(slice.traveler.id))?.[0];
  const owner = flow.form.travelers.find(({ traveler }) => traveler.id === holderId);
  return owner && owner.traveler.id !== requesterId
    ? labels.allocationFromGuest(owner.form?.traveler?.name ?? owner.traveler.name)
    : labels.allocationFromRequester;
}
